import axiosInstance from "./AxiosConfig";

// Crear árbol de llaves
const crearArbol = async (tournamentTree, idTorneoCategoria) => {
  console.log("tournamentTree de llaveService", tournamentTree);
  const response = await axiosInstance.post("api/llaves/crearArbol", {
    tournamentTree,
    idTorneoCategoria,
  });
  console.log("response:", response);
  return response.data;
};

// Obtener llaves por torneo/categoría
const obtenerLlavesPorTorneoCategoria = async (idTorneoCategoria) => {
  const response = await axiosInstance.get(`api/llaves/porTorneoCategoria/${idTorneoCategoria}`);
  return response.data;
};

// Obtener partidos estructurados desde el backend
const obtenerPartidosEstructurados = async (idTorneoCategoria) => {
  const response = await axiosInstance.get(`api/llaves/arbol/${idTorneoCategoria}`);
  return response.data; // Backend debe devolver los partidos procesados
};

const llaveService = {
  crearArbol,
  obtenerLlavesPorTorneoCategoria,
  obtenerPartidosEstructurados,
};

export default llaveService;